import React, { useState } from 'react';
import PrintingMachinesSection from 'components/quote_builder_widget/sections/PrintingMachinesSection';
import SectionMenuLayout, { activeSubsection } from 'components/quote_builder_widget/shared/SectionMenuLayout';
import styles from 'components/quote_builder_widget/settings/_style.module.scss';

const PRINTING_SECTIONS = [
  { id: 'printing_machines', label: 'quote_builder_widget.printing_menu_machines', Content: PrintingMachinesSection },
];

const PrintingSection = ({ activeSection, onSectionChange, onChange }) => {
  const [addedCount, setAddedCount] = useState();
  const active = activeSubsection(PRINTING_SECTIONS, activeSection);
  const { Content } = active;

  return (
    <SectionMenuLayout
      label={t('quote_builder_widget.section_printing')}
      sections={PRINTING_SECTIONS.map((section) => ({ ...section, count: addedCount }))}
      activeId={active.id}
      onSectionChange={onSectionChange}
    >
      <div className={styles.fieldGroup}>
        <Content key={active.id} onPrintingMachinesChange={onChange} onAddedCountChange={setAddedCount} />
      </div>
    </SectionMenuLayout>
  );
};

export default PrintingSection;
